class CartDrawerFooter extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".cart-drawer-utility-btn");
    this.overlay = this.querySelector(".cart-drawer-panel-overlay");
    this.panels = this.querySelectorAll(".cart-drawer-panel");

    this.bindEvents();
  }

  bindEvents() {
    // Open Panel
    this.buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetId = btn.getAttribute("aria-controls");
        this.openPanel(targetId);
      });
    });

    // Close on Overlay Click
    if (this.overlay) {
      this.overlay.addEventListener("click", this.closeAllPanels.bind(this));
    }

    // Close on X Button or Apply Button
    this.panels.forEach((panel) => {
      const closeBtn = panel.querySelector(".cart-drawer-panel__close");
      const applyBtn = panel.querySelector(".cart-drawer-panel__apply");

      if (closeBtn)
        closeBtn.addEventListener("click", this.closeAllPanels.bind(this));

      if (applyBtn) {
        applyBtn.addEventListener("click", () => {
          // Blur textarea to force Shopify's default 'cart-drawer-note' save trigger
          const textarea = panel.querySelector("textarea");
          if (textarea) textarea.blur();
          this.closeAllPanels();
        });
      }
    });
  }

  openPanel(panelId) {
    const targetPanel = document.getElementById(panelId);
    if (!targetPanel) return;

    // Close any other open panels first
    this.closeAllPanels();

    // Open targeted panel
    targetPanel.classList.add("is-active");
    targetPanel.setAttribute("aria-hidden", "false");
    if (this.overlay) this.overlay.classList.add("is-active");
  }

  closeAllPanels() {
    this.panels.forEach((panel) => {
      panel.classList.remove("is-active");
      panel.setAttribute("aria-hidden", "true");
    });
    if (this.overlay) this.overlay.classList.remove("is-active");
  }
}

customElements.define("cart-drawer-footer", CartDrawerFooter);
